<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Contacts</span>
        <span slot="title">Contacts</span>
      </AffixHeader>

      <template v-if="$can('manage', 'contacts')">
        <i-button type="primary" @click="$router.push('/contacts/new')">
          <FFIcon type="plus" />New Contact
        </i-button>
        <br />
        <br />
      </template>

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="80" label-position="right">
          <Row>
            <i-col span="12">
              <i-form-item label="Name">
                <i-input v-model="form.name"></i-input>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Job Title">
                <i-input v-model="form.job_title"></i-input>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Organisation">
                <i-input v-model="form.organisation"></i-input>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Gender">
                <RadioGroup v-model="form.gender">
                  <Radio label="Any">
                    <span>Any</span>
                  </Radio>
                  <Radio label="Male">
                    <FFIcon type="male" />
                    <span>Male</span>
                  </Radio>
                  <Radio label="Female">
                    <FFIcon type="female" />
                    <span>Female</span>
                  </Radio>
                </RadioGroup>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Countries">
                <CountrySelect v-model="form.countries_of_operation" filterable multiple></CountrySelect>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Region" style="margin-right:6px;">
                <i-select v-model="form.regions" filterable multiple>
                  <i-option value="Latin America and the Caribbean">Latin America and the Caribbean</i-option>
                  <i-option value="North America">North America</i-option>
                  <i-option value="South Asia">South Asia</i-option>
                  <i-option value="Sub-Saharan Africa">Sub-Saharan Africa</i-option>
                  <i-option value="Middle East and North Africa">Middle East and North Africa</i-option>
                  <i-option value="East Asia and Pacific">East Asia and Pacific</i-option>
                  <i-option value="Europe and Central Asia">Europe and Central Asia</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>

          <Row type="flex" justify="end">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>

      <br />
      <ContactsTable :conditions="conditions"></ContactsTable>
    </i-col>
  </Row>
</template>

<script>
import ContactsTable from "@/contacts/table.vue";
import CountrySelect from "@/components/country_select";
import { getTsQueryValue } from "@/utils/common";

const emptyForm = {
  name: "",
  type: "",
  job_title: "",
  organisation: "",
  gender: "Any",
  countries_of_operation: [],
  regions: [],
};

export default {
  components: {
    ContactsTable,
    CountrySelect,
  },

  data() {
    return {
      form: Object.assign({}, emptyForm),
      conditions: {},
    };
  },

  methods: {
    search() {
      let conditions = {};

      // Name
      if (this.form.name !== "") {
        conditions["full_name"] = getTsQueryValue(this.form.name);
      }

      // Job Title
      if (this.form.job_title !== "") {
        conditions["job_title"] = getTsQueryValue(this.form.job_title);
      }

      // Organisation
      if (this.form.organisation !== "") {
        conditions["organisation"] = getTsQueryValue(this.form.organisation);
      }

      // Gender
      if (this.form.gender !== "Any") {
        conditions["gender"] = `eq.${this.form.gender}`;
      }

      let orConditions = [];
      // Countries of operation
      // if (this.form.countries_of_operation.length > 0) {
      //   let criteria = this.form.countries_of_operation.map(
      //     country => `countries_of_operation.cs.["${country}"]`
      //   );
      //   conditions["or"] = `(${criteria.join(",")})`;
      //   console.log(conditions["or"]);
      //   // conditions["countries_of_operation"] =
      //   //   "cs." + JSON.stringify(this.form.countries_of_operation);
      // }

      // Countries of operation
      if (this.form.countries_of_operation.length > 0) {
        let criteria = this.form.countries_of_operation.map(
          country => `countries_of_operation.cs.["${country}"]`
        );
        orConditions = orConditions.concat(criteria);
      }

      // regions
      if (this.form.regions.length > 0) {
        let criteria = this.form.regions.map(
          regions => `regions.cs.{"${regions}"}`
        );
        orConditions = orConditions.concat(criteria);
      }

      // Serial No.
      if (this.form.type !== "") {
        conditions["type"] = getTsQueryValue(this.form.type);
      }

      if (orConditions.length > 0) {
        conditions["or"] = `(${orConditions.join(",")})`;
      }

      this.conditions = conditions;
    },

    reset() {
      this.form = Object.assign({}, emptyForm);
      this.conditions = {};
    },
  },
};
</script>

<style lang="css"></style>
